import { render, staticRenderFns } from "./CardDataEventsPopup.vue?vue&type=template&id=ffbba506&"
import script from "./CardDataEventsPopup.vue?vue&type=script&lang=js&"
export * from "./CardDataEventsPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports